import Util from "@/_utils/util"

export const adConfig = {
    test: {
        article_zmtq: {
            middleInsertAd: {
                isSingleAd: true,
                adInfo: {
                    posCode: 10528,
                    rule: 1,
                    fixArray: [
                        1
                    ]
                },
                spmCCode: 'middleInsertAd',
                resourceId: '399991713430779000'
            },
            middleBannerAd: {
                isSingleAd: true,
                adInfo: {
                    posCode: 10527,
                    rule: 1,
                    fixArray: [
                        1
                    ],
                },
                spmCCode: 'a-mb',
                resourceId: '399991713430809000'
            },
            articleEndAd: {
                isSingleAd: true,
                adInfo: {
                    posCode: 10529,
                    rule: 1,
                    fixArray: [
                        1
                    ],
                },
                spmCCode: 'end-advertising',
                resourceId: '399991713790650000'
            }
        },
    },
    prod: {
        article_zmtq: {
            middleInsertAd: {
                isSingleAd: true,
                adInfo: {
                    posCode: 10598,
                    rule: 1,
                    fixArray: [
                        1
                    ],
                },
                spmCCode: 'middleInsertAd',
                resourceId: '399991713430779000'
            },
            middleBannerAd: {
                isSingleAd: true,
                adInfo: {
                    posCode: 10597,
                    rule: 1,
                    fixArray: [
                        1
                    ]
                },
                spmCCode: 'a-mb',
                resourceId: '399991713430809000'
            },
            articleEndAd: {
                isSingleAd: true,
                adInfo: {
                    posCode: 10599,
                    rule: 1,
                    fixArray: [
                        1
                    ]
                },
                spmCCode: 'end-advertising',
                resourceId: '399991713790661000'
            }
        },
    }
}

/**
 * @description 普通文章页广告配置映射
 */
const articleAdConfigMap = {
    test: {
        //顶部通栏位置
        topBanner : {
            resourceId: "999326167825842182", // spid:10456
            spmCCode: "a-tb",
            size: 1,
            "posCode": "10456",
            "rule": 1,
            "fixArray": [
                1,
                2
            ]
        },
        // 底部通栏位置
        bottomBanner : {
            resourceId: "999326167825842177", //spid:10452
            spmCCode: "b-mb",
            size: 1,
            "posCode": "10469",
            "rule": 1,
            "fixArray": [
                1
            ]

        },
        // 中部文字链
        middleText: {
            resourceId: "999326167825842178",// spid:10453
            spmCCode: "a-mt",
            size: 1,
            "posCode": "10453",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 中部通栏
        middleBanner: {
            resourceId: "999326167825842179",//spid:10454
            spmCCode: "a-mb",
            size: 1,
            "posCode": "10454",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 中插
        middleInsertAd: {
            resourceId: "999326167825842180",// spid:10455
            spmCCode: "content",
            size: 1,
            "posCode": "10455",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 点击文章内图片后底部广告
        imageAd: {
            resourceId: "4999991680234994972", // sspid: 10211
            spmCCode: 'picture-read-ad',
            size: 1,
            useMkey: true,
            "posCode": "10475",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 顶部导航右侧轮换广告1
        topRightSlide1: {
            resourceId: '499991677657384746',
            spmCCode: 'nav',
            index: 1,
            "posCode": "10128",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 顶部导航右侧轮换广告2
        topRightSlide2: {
            resourceId: '499991677657045458',
            spmCCode: 'nav',
            index: 2,
            "posCode": "10484",
            "rule": 1,
            "fixArray": [
                1,
                2
            ]
        },
    },
    prod: {
        //顶部通栏位置
        topBanner : {
            resourceId: "999326167825842182",
            spmCCode: "a-tb",
            size: 1,
            "posCode": "10103",
            "rule": 1,
            "fixArray": [
                1,
                2
            ]
        },
        // 中部文字链
        middleText: {
            resourceId: "999326167825842178",
            spmCCode: "a-mt",
            size: 1,
            "posCode": "10106",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 中部通栏
        middleBanner: {
            resourceId: "999326167825842179",
            spmCCode: "a-mb",
            size: 1,
            "posCode": "10105",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#middleBanner'
        },
        // 中插
        middleInsertAd: {
            resourceId: "999326167825842180",
            spmCCode: "content",
            size: 1,
            "posCode": "10104",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 底部通栏位置
        bottomBanner : {
            resourceId: "999326167825842177",
            spmCCode: "b-mb",
            size: 1,
            "posCode": "10107",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 点击文章内图片后底部广告
        imageAd: {
            resourceId: "4999991680234994972",
            spmCCode: 'picture-read-ad',
            size: 1,
            useMkey: true,
            "posCode": "10300",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 顶部导航右侧轮换广告1
        topRightSlide1: {
            resourceId: '499991677657384746',
            spmCCode: 'nav',
            index: 1,
            "posCode": "10108",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 顶部导航右侧轮换广告2
        topRightSlide2: {
            resourceId: '499991677657045458',
            spmCCode: 'nav',
            index: 2,
            "posCode": "10109",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
    }
}

const articleAbroadAdConfigMap = {
    test: {
        // 分享下方评论上方Taboola广告
        shareBottomTaboola: {
            resourceId: '1166414867511574528',
            spmCCode: 'a-content-end',
            index: 1,
            size: 1,
            "posCode": "10514",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // momagic插屏广告，测试环境
        momagicAd: {
            resourceId: "1210585653914566656",
            spmCCode: "a-momagic",
            index: 1,
            "posCode": "10524",
            "mergeType": 1,
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#taboolaContainer'
        },
        // 文末和分享上方Onemob广告
        shareTopOneMob: {
            resourceId: '1166414827678269440',
            spmCCode: 'a-content-end',
            index: 1,
            el: '#onemobContainer',
            "posCode": "10513",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        articleEndAd: {
            resourceId: "999326167825842180",// spid:10455
            spmCCode: "content",
            size: 1,
            el: "#articleContent",
            "posCode": "10455",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 底部通栏位置
        bottomBanner : {
            resourceId: "999326167825842177", //spid:10452
            spmCCode: "b-mb",
            size: 1,
            "posCode": "10469",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 无固定位置vidoomy
        vidoomyAd: {
            resourceId: "1178700951733862400",
            spmCCode: "a-vidoomy",
            size: 1,
            index: 1,
            "posCode": "10522",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
    },
    prod: {
        // 分享下方评论上方Taboola广告
        shareBottomTaboola: {
            resourceId: '1166414780295217152',
            spmCCode: 'a-content-end',
            index: 1,
            size: 1,
            "posCode": "10578",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // momagic插屏广告，正式环境
        momagicAd: {
            resourceId: "1210595844076797952",
            spmCCode: "a-momagic",
            index: 1,
            "posCode": "10594",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#taboolaContainer'
        },
        // 文末和分享上方Onemob广告
        shareTopOneMob: {
            resourceId: '1166414719930793984',
            spmCCode: 'a-content-end',
            index: 1,
            "posCode": "10577",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#onemobContainer'
        },
        articleEndAd: {
            resourceId: "999326167825842180",
            spmCCode: "content",
            size: 1,
            "posCode": "10104",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: "#articleContent"
        },
        // 底部通栏位置
        bottomBanner : {
            resourceId: "999326167825842177",
            spmCCode: "b-mb",
            size: 1,
            "posCode": "10107",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 无固定位置vidoomy
        vidoomyAd: {
            resourceId: "1178701032553906176",
            spmCCode: "a-vidoomy",
            size: 1,
            index: 1,
            "posCode": "10581",
            "rule": 1,
            "mergeType": 0,
            "fixArray": [
                1
            ]
        },
    }
}

/**
 * @description 花生地铁广告配置映射
 */
const articleHsdtAdConfigMap = {
    test: {
        // 花生地铁广告
        middleInsertAdHSDT:{
            resourceId:"997209846560523331", //spid:10183
            spmCCode:"pr-big",
            "posCode": "10445",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: "#prBig"
        },
    },
    prod: {
        // 花生地铁广告
        middleInsertAdHSDT:{
            resourceId:"997209846560523331", //spid:10183
            spmCCode:"pr-big",
            "posCode": "10183",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: "#prBig"
        },
    }
}

/**
 * @description 黑鲨广告配置映射
 */
const articleHeishaAdConfigMap = {
    test: {
        // 黑鲨底通广告
        bottomBanner:{
            resourceId:"997209846560523330", //spid:10184
            spmCCode:"end-advertising",
            "posCode": "10444",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
    },
    prod: {
        // 黑鲨底通广告
        bottomBanner:{
            resourceId:"997209846560523330", //spid:10184
            spmCCode:"end-advertising",
            "posCode": "10184",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
    }
}

/**
 * @description 黄历天气广告配置映射
 */
const articleHltqAdConfigMap = {
    test: {
        bottomBanner: {
            resourceId:"997209846560523332",
            spmCCode:"end-advertising",
            "posCode": "10446",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
    },
    prod: {
        bottomBanner: {
            resourceId:"997209846560523332",
            spmCCode:"end-advertising",
            "posCode": "10182",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
    }
}

/**
 * @description 微信文章页广告配置映射
 */
const articleWeiXinAdConfigMap = {
    test: {
        // 底部通栏位置
        bottomBanner : {
            resourceId: "999326167825842177", //spid:10452
            spmCCode: "b-mb",
            size: 1,
            "posCode": "10469",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        //插屏广告
        insertScreenAd: {
            resourceId: "1035225217464729600",//spid:10196
            spmCCode: "a-insert",
            size: 1,
            "posCode": "10196",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 中插
        middleInsertAd: {
            resourceId: "999326167825842180",// spid:10455
            spmCCode: "content",
            size: 1,
            "posCode": "10455",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 文章底部悬浮区域广告
        footerAd: {
            spmCCode: "WxArticleFooter",
            resourceId: "399991634725777115",
            "posCode": "10091",
            "rule": 1,
            "fixArray": [
                1
            ]
        }
    },
    prod: {
        // 底部通栏位置
        bottomBanner : {
            resourceId: "999326167825842177",
            spmCCode: "b-mb",
            size: 1,
            "posCode": "10107",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        //插屏广告
        insertScreenAd: {
            resourceId: "1035225652833484800",
            spmCCode: "a-insert",
            size: 1,
            "posCode": "10202",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 中插
        middleInsertAd: {
            resourceId: "999326167825842180",
            spmCCode: "content",
            size: 1,
            "posCode": "10104",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        // 文章底部悬浮区域广告
        footerAd: {
            spmCCode: "WxArticleFooter",
            resourceId: "399991634725777115",
            "posCode": "10061",
            "rule": 1,
            "fixArray": [
                1
            ]
        }
    }
}

/**
 * @description 图集页广告配置映射
 */
const galleryAdConfigMap = {
    test: {
        bottomBanner: {
            resourceId: "999326167825842183",
            spmCCode: "db-tonglan",
            "posCode": "10475",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        lastAd: {
            resourceId: "399991718959439000",
            spmCCode: "pics",
            "posCode": "10531",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        middleInsertAd: {
            resourceId: "999326167825842184",
            spmCCode: "zc-ad",
            "posCode": "10474",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        middleBannerAd: {
            resourceId:'999326167825842185',
            spmCCode: "rec",
            "posCode": "10479",
            "rule": 1,
            "fixArray": [
                1
            ]
        }
    },
    prod: {
        bottomBanner: {
            resourceId: "999326167825842183",
            spmCCode: "db-tonglan",
            "posCode": "10178",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        lastAd: {
            resourceId: "399991718959439000",
            spmCCode: "pics",
            posCode: "10601",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        middleInsertAd: {
            resourceId: "999326167825842184",
            spmCCode: "zc-ad",
            "posCode": "10179",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        middleBannerAd: {
            resourceId:'999326167825842185',
            spmCCode: "rec",
            "posCode": "10180",
            "rule": 1,
            "fixArray": [
                1
            ]
        }
    }
}

/**
 * @description 老文章页广告配置映射
 */
const articleWcmsAdConfigMap = {
    test: {
        topBannerAd: {
            resourceId:"1054526951072661504",
            spmCCode:"a-tb",
            el: '.top-bill-wrapper',
            "posCode": "10439",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        middleTextAd: {
            resourceId:"1054527194518454272", //spid:10282
            spmCCode:"a-mt",
            el: '#middleText',
            "posCode": "10438",
            "rule": 1,
            "fixArray": [
                1
            ]

        },
        middleBannerAd: {
            resourceId:"1054527134653153280", //spid:10280
            spmCCode:"a-mb",
            el: "#middleBanner",
            "posCode": "10440",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        middleInsertAd: {
            resourceId:"1054525996822364160", //spid:10278
            spmCCode:"article-end",
            el: ".article-content",
            "posCode": "10442",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        bottomBannerAd: {
            resourceId:"1054527301980717056", //spid:10283
            spmCCode:"b-mb",
            el: "#bottomBanner",
            "posCode": "10437",
            "rule": 1,
            "fixArray": [
                1
            ]
        }
    },
    prod: {
        topBannerAd: {
            resourceId:"1054526951072661504",
            spmCCode:"a-tb",
            el: '.top-bill-wrapper',
            "posCode": "10281",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        middleTextAd: {
            resourceId:"1054527194518454272", //spid:10282
            spmCCode:"a-mt",
            el: '#middleText',
            "posCode": "10282",
            "rule": 1,
            "fixArray": [
                1
            ],
            el: '#middleText'
        },
        middleBannerAd: {
            resourceId:"1054527134653153280", //spid:10280
            spmCCode:"a-mb",
            el: "#middleBanner",
            "posCode": "10280",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        middleInsertAd: {
            resourceId:"1054525996822364160",
            spmCCode:"article-end",
            el: ".article-content",
            "posCode": "10278",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        bottomBannerAd: {
            resourceId:"1054527301980717056", //spid:10283
            spmCCode:"b-mb",
            el: "#bottomBanner",
            "posCode": "10283",
            "rule": 1,
            "fixArray": [
                1
            ]
        }
    }
}

/**
 * @description 焦点文章页广告配置映射
 */
const articleFocusAdConfigMap = {
    test: {
        bottomBannerAd: {
            resourceId: "3999991686643707000",
            spmCCode: "bottom-banner",
            "posCode": "10277",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        topSlide1: {
            resourceId: "3999991686410920000", // 3999991686410920000 sspid: 10346,
            spmCCode: "ad-slide",
            size: 1,
            "posCode": "10278",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        topSlide2: {
            resourceId: "3999991686540730000",
            spmCCode: "ad-slide",
            size:1,
            "posCode": "10280",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        topSlide3: {
            resourceId: "3999991686540765000",
            spmCCode: "ad-slide",
            size:1,
            index: 3,
            "posCode": "10281",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        topSlide4: {
            resourceId: "3999991686540889000",
            spmCCode: "ad-slide",
            size:1,
            index: 4,
            "posCode": "10282",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        relativeInfo: {
            resourceId: "3999991686622857000",
            spmCCode: "fd-d",
            "posCode": "10279",
            "rule": 1,
            "fixArray": [
                1
            ]
        }
    },
    prod: {
        bottomBannerAd: {
            resourceId: "3999991686643707000",
            spmCCode: "bottom-banner",
            "posCode": "10346",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        topSlide1: {
            resourceId: "3999991686410920000", // sspid: 10346,
            spmCCode: "ad-slide",
            size: 1,
            index: 1,
            "posCode": "10345",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        topSlide2: {
            resourceId: "3999991686540730000",
            spmCCode: "ad-slide",
            size:1,
            index: 2,
            "posCode": "10348",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        topSlide3: {
            resourceId: "3999991686540765000",
            spmCCode: "ad-slide",
            size:1,
            index: 3,
            "posCode": "10349",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        topSlide4: {
            resourceId: "3999991686540889000",
            spmCCode: "ad-slide",
            size:1,
            index: 4,
            "posCode": "10350",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
        relativeInfo: {
            resourceId: "3999991686622857000",
            spmCCode: "fd-d",
            "posCode": "10347",
            "rule": 1,
            "fixArray": [
                4,
                8
            ]
        }
    }
}

/**
 * @description 焦点家居文章页广告配置映射
 */
const articleFocusHomeAdConfigMap = {
    test: {
        // 阿波罗未配置
        topSlide1: {
            resourceId: "3999991699273393000", // sspid: 10556,
            spmCCode: "ad-top1",
            size: 1,
            index: 1,
        },
        // 阿波罗未配置
        topSlide2: {
            resourceId: "3999991699273337000", // sspid: ,
            spmCCode: "ad-top2",
            size: 1,
            index: 1,
        },
        // 阿波罗未配置
        topSlide3: {
            resourceId: "3999991699273352000", // sspid: ,
            spmCCode: "ad-top3",
            size: 1,
            index: 1,
        },
        // 阿波罗未配置
        topSlide4: {
            resourceId: "3999991699273372000", // sspid: ,
            spmCCode: "ad-top4",
            size: 1,
            index: 1,
        },
        // 阿波罗未配置
        relativeInfo: {
            resourceId: "3999991699273390000",
            spmCCode: "ad-xgzx",
        },
        // 焦点底部通栏
        bottomBanner1: {
            resourceId: "3999991699273327000",
            spmCCode: "ad-bottom1",
            "posCode": "10521",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
    },
    prod: {
        // 未配置阿波罗
        topSlide1: {
            resourceId: "3999991699273393000",
            spmCCode: "ad-top1",
            size: 1,
            index: 1,
        },
        // 未配置阿波罗
        topSlide2: {
            resourceId: "3999991699273337000",
            spmCCode: "ad-top2",
            size: 1,
            index: 1,
        },
        // 未配置阿波罗
        topSlide3: {
            resourceId: "3999991699273352000",
            spmCCode: "ad-top3",
            size: 1,
            index: 1,
        },
        // 未配置阿波罗
        topSlide4: {
            resourceId: "3999991699273372000",
            spmCCode: "ad-top4",
            size: 1,
            index: 1,
        },
        // 未配置阿波罗
        relativeInfo: {
            resourceId: "3999991699273390000",
            spmCCode: "ad-xgzx",
        },
        // 焦点底部通栏
        bottomBanner1: {
            resourceId: "3999991699273327000", 
            spmCCode: "ad-bottom1",
            "posCode": "10556",
            "rule": 1,
            "fixArray": [
                1
            ]
        },
    }
}

const isTest = Util.isTestEnvironment()
/**
 * @description 普通文章页广告配置
 */
export const articleAdConfig = isTest ? articleAdConfigMap.test : articleAdConfigMap.prod
/**
 * @description 海外文章页广告配置
 */
export const articleAbroadAdConfig = isTest ? articleAbroadAdConfigMap.test : articleAbroadAdConfigMap.prod
/**
 * @description 花生地铁广告配置
 */
export const articleHsdtAdConfig = isTest ? articleHsdtAdConfigMap.test : articleHsdtAdConfigMap.prod
/**
 * @description 黑鲨广告配置
 */
export const articleHeishaAdConfig = isTest ? articleHeishaAdConfigMap.test : articleHeishaAdConfigMap.prod
/**
 * @description 黄历天气广告配置
 */
export const articleHltqAdConfig = isTest ? articleHltqAdConfigMap.test : articleHltqAdConfigMap.prod
/**
 * @description 微信文章页广告配置
 */
export const articleWeiXinAdConfig = isTest ? articleWeiXinAdConfigMap.test : articleWeiXinAdConfigMap.prod
/**
 * @description 图集页广告配置
 */
export const galleryAdConfig = isTest ? galleryAdConfigMap.test : galleryAdConfigMap.prod
/**
 * @description 老文章页广告配置
 */
export const articleWcmsAdConfig = isTest ? articleWcmsAdConfigMap.test : articleWcmsAdConfigMap.prod
/**
 * @description 焦点文章页广告配置
 */
export const articleFocusAdConfig = isTest ? articleFocusAdConfigMap.test : articleFocusAdConfigMap.prod
/**
 * @description 焦点家居文章页广告配置
 */
export const articleFocusHomeAdConfig = isTest ? articleFocusHomeAdConfigMap.test : articleFocusHomeAdConfigMap.prod